import { Link } from "react-router-dom";
import { specials } from "@/mocks/specials";
import { getFilmsByIds } from "@/lib/films";

export default function SpecialsSection() {
  return (
    <section id="specials" className="mx-auto w-full max-w-6xl scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
      <div>
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
          <i className="ri-bookmark-3-line text-sm" />
          精选剧情专题
        </span>
        <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">主题策划 · 成体系地读懂影视</h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
          我们把风格相近、主题呼应的作品整理成专题，用一条线索串起多部影视，让阅读更有脉络。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
        {specials.map((topic, index) => {
          const topicFilms = getFilmsByIds(topic.filmIds);
          return (
            <Link
              key={topic.id}
              to={`/special/${topic.id}`}
              className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${
                index === 0 ? "md:col-span-2" : ""
              }`}
            >
              <div className={`relative w-full overflow-hidden bg-background-200 ${index === 0 ? "h-52 md:h-64" : "h-44"}`}>
                <img
                  src={topic.cover}
                  alt={`${topic.title}专题封面`}
                  title={`${topic.title} ${topic.subtitle}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/35 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="text-xs font-medium text-accent-300">{topic.subtitle}</span>
                  <h3 className="mt-1 font-heading text-xl font-bold text-background-50 md:text-2xl">{topic.title}</h3>
                </div>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <p className="text-sm leading-relaxed text-foreground-600 line-clamp-2">{topic.intro}</p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  {topicFilms.map((film) => (
                    <span key={film.id} className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-700">
                      {film.title}
                    </span>
                  ))}
                </div>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-accent-600">
                  查看专题
                  <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}